import styled from 'styled-components/macro';

export const Content = styled.div`
  margin-top: 2rem;
`;
